<div *ngIf="orgAnnouncements" class="org-announcements" tabindex="0">
  <div class="l_flex m-l_flex guts-p-full-1-half oh org-announcements--{{ mode }}">
    <h1 class="a11y-hide">{{ 'OrgAnnouncement_Label' | translate }}</h1>
    <div
      class="guts-m-r-1 l_flex-shrink rounded org-announcements__image"
      [class]="useIllustration ? 'org-announcements__image--illustration' : ''"
    >
      <img [src]="imgSrc" aria-role="presentation" />
    </div>
    <div class="l_flexbar l_flex-grow">
      <span class="l_flex-grow org-announcements__text-section">
        <h2 class="org-announcements--title font-semibold par par--small">
          {{ orgAnnouncements.title || defaultTitle }}
        </h2>
        <p class="par par--light_a par--small">
          {{ orgAnnouncements.description }}
          <a
            *ngIf="orgAnnouncements.linkUrl && orgAnnouncements.linkName"
            target="_blank"
            class="color-blue font-semibold no-wrap"
            (click)="linkClicked()"
            [href]="orgAnnouncements.linkUrl"
            data-dgat="org-announcements-a91"
            >{{ orgAnnouncements.linkName
            }}<df-icon
              class="color-blue guts-m-l-half"
              icon="chevron-right"
              size="extra-small"
            ></df-icon
          ></a>
        </p>
      </span>
      <df-icon
        *ngIf="showDismiss"
        role="button"
        [attr.aria-label]="i18n.Core_Close"
        class="cursor-pointer color-ebony-a61"
        size="medium"
        icon="cross"
        (click)="dismiss()"
        tabindex="0"
      ></df-icon>
    </div>
  </div>
</div>
